import React from 'react';

// https://codepen.io/baarbaracrr/pen/KKovmGb

const AnimatedBackground = () => {
  return (
    <div className="focus-space-animated-background">
      <div className="wave"></div>
      <div className="wave"></div>
      <div className="wave"></div>
    </div>
  );
};

export default AnimatedBackground;
